var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwilioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.486502 0 0 .486502 4.830457 17.448139)",
    fill: "#e31e26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.9 5.1h-12.1a.65.65 0 0 0-.6.6v7a.65.65 0 0 0 .6.6h12.1a.65.65 0 0 0 .6-.6v-7c0-.4-.2-.6-.6-.6zm-.2 10.4h-23.2c-.3 0-.7.3-.8.6l-3 11.4-.2.6-3.5-12.2c-.1-.3-.4-.6-.8-.6h-9c-.3 0-.7.3-.8.6L115 27.3l-.2.6-.2-.6-2.8-11.2c-.1-.3-.4-.6-.8-.6H92.9V5.7c0-.3-.4-.7-.8-.5L80.6 8.7c-.3.1-.6.3-.6.6v6.2h-3a.65.65 0 0 0-.6.6v8.7a.65.65 0 0 0 .6.6h3V36c0 7.5 4.1 11 11.7 11 3.1 0 6.2-.7 8.2-1.8v-9c0-.5-.4-.6-.6-.5-1.2.5-2.2.7-3.3.7-2 0-3.1-.8-3.1-3.2v-7.8h6.5a.65.65 0 0 0 .6-.6v-7.3l8.6 28.6c.1.3.4.6.8.6h9.5c.3 0 .7-.3.8-.6l4.1-12.7 4 12.6c.1.3.5.6.8.6h9.5c.3 0 .7-.3.8-.6l8.7-28.7V46a.65.65 0 0 0 .6.6h11.6a.65.65 0 0 0 .6-.6V16.1c-.1-.4-.4-.6-.7-.6zM175 5.1h-11.6a.65.65 0 0 0-.6.6V46a.65.65 0 0 0 .6.6H175a.65.65 0 0 0 .6-.6V5.7c0-.4-.3-.6-.6-.6zm15.5 0h-12.1a.65.65 0 0 0-.6.6v7a.65.65 0 0 0 .6.6h12.1a.65.65 0 0 0 .6-.6v-7c0-.4-.2-.6-.6-.6zm-.2 10.4h-11.6a.65.65 0 0 0-.6.6V46a.65.65 0 0 0 .6.6h11.6a.65.65 0 0 0 .6-.6V16.1c0-.4-.3-.6-.6-.6zm19.2-.8c-10.2 0-17.4 7.5-17.4 16.2v.1c0 8.7 7.2 16.1 17.3 16.1 10.2 0 17.4-7.5 17.4-16.2v-.1c.1-8.7-7.1-16.1-17.3-16.1zm5 16.3c0 2.9-2.1 5.4-5 5.4-2.8 0-5.1-2.4-5.1-5.5v-.1c0-2.9 2.1-5.4 5-5.4 2.8 0 5.1 2.4 5.1 5.5zM34.1-8.3C15.3-8.3 0 7 0 25.8s15.3 34.1 34.1 34.1C53 60 68.3 44.7 68.3 25.8S53-8.3 34.1-8.3zm0 59.3C20.3 51 9 39.7 9 25.8 9 12 20.3.7 34.1.7 48 .7 59.3 12 59.3 25.8 59.3 39.7 48 51 34.1 51z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.1,
    cy: 17.3,
    cx: 42.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.1,
    cy: 34.3,
    cx: 42.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.1,
    cy: 34.3,
    cx: 25.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.1,
    cy: 17.3,
    cx: 25.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwilioLogo);
export default __webpack_public_path__ + "static/media/twilio-logo.0cbc52267fca3e92c64b1e7e47537e69.svg";
export { ForwardRef as ReactComponent };